/** Product branding — single source of truth for UI and transactional email footers. */
/** Google Workspace inbox — mailto links, support, legal, and Reply-To for Resend mail. */
const CONTACT_EMAIL = 'ceo@renewaldrive.com';

/** Resend-verified sending domain (SPF/DKIM). From addresses only — not shown as contact mailto. */
export const RESEND_MAIL_DOMAIN = 'mail.renewaldrive.com';

export const BRAND = {
  name: 'Renewal Drive',
  /** Hero headline — outcome-focused for service shop owners. */
  tagline: 'Win more maintenance agreement renewals, before customers slip away.',
  description:
    "For HVAC, plumbing, electrical, and other service shops: see who won't renew, who to call first, and automate email, text, and renewal follow-ups so you keep more customers, and win back the ones slipping away.",
  domain: 'renewaldrive.com',
  /** General contact — legal, billing questions, support mailto links. */
  helloEmail: CONTACT_EMAIL,
  /** Primary Google Workspace inbox — support form destination and Reply-To for platform Resend mail. */
  supportEmail: CONTACT_EMAIL,
  supportEmailLabel: 'CEO, Renewal Drive',
  privacyEmail: CONTACT_EMAIL,
  securityEmail: CONTACT_EMAIL,
  /** Reply-To when sending from @mail.renewaldrive.com via Resend (verify, password reset, etc.). */
  replyToEmail: CONTACT_EMAIL,
  /** Default Resend From for account/transactional mail (must stay on verified mail. subdomain). */
  resendTransactionalFrom: `CEO, Renewal Drive <ceo@${RESEND_MAIL_DOMAIN}>`,
  /** Default Resend From for customer renewal reminders. */
  resendRemindersFrom: `Renewal Drive <reminders@${RESEND_MAIL_DOMAIN}>`,
  poweredBy: 'Powered by Renewal Drive',
  copyright: `© ${new Date().getFullYear()} Renewal Drive`,
} as const;
